import React, { useEffect, useState } from "react";
import LeaveApplyFormStyles from "./LeaveApplyForm.styles";
import {
  Autocomplete,
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import CustomInput from "../../../../global/components/CustomInput/CustomInput";
import CustomButton from "../../../../global/components/CustomButton/CustomButton";
import CustomRadioButton from "../../../../global/components/CustomRadioButton/CustomRadioButton";
import { addUserLeave } from "./LeaveApplyFormService";
import { useAppSelector } from "../../../../utils/hooks";
import { selectUserId } from "../../../../redux/authSlice";
import {
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "../../../../helpers/methods";
import notifiers from "../../../../global/constants/NotificationConstants";
import customErrorHandler from "../../../../utils/customErrorHandler";
import CustomLoader from "../../../../global/components/CustomLoader/CustomLoader";
import moment from 'moment';
import { store } from "../../../../utils/store";
import { getLeave } from "../../LeaveService";
import { applyLicenseKey } from "../../../../utils/License";

const options = ["Earned Leave", "Casual Leave", "Sick Leave"];

interface CustomProps {
  nextStep?: () => void | undefined;
  handleclose?: Function;
  leaveInfo?:any
}
const userName = store.getState();
const LeaveApplyForm = (props: CustomProps) => {
  const classes = LeaveApplyFormStyles;
  const userId = useAppSelector(selectUserId);
  const [apiResponse, setApiResponse] = useState(false);
   useEffect(() => {
      applyLicenseKey();
    }, []);
  const [leaveInfo ,setLeaveInfo] = useState({})
  const [formState, setFormState] = useState({
    name: "",
    leavesRemaining: "",
    leave_type: options[0],
    totalLeave: "",
    from_date: "",
    to_date: "",
    comments: "",
    leaveType: 0,
  });
  console.log(props,"check")

  const [errors, setErrors] = useState({
    leave_type: "",
    from_date: "",  
    to_date: "",
    comments: "",
  });
 
  const validateFields = () => {
    let isValid = true;
    const updatedErrors = { ...errors };

    // Validate leave_type
    if (!formState.leave_type) {
      updatedErrors.leave_type = "Leave type is required";
      isValid = false;
    } else {
      updatedErrors.leave_type = "";
    }

    // Validate from_date
    if (!formState.from_date) {
      updatedErrors.from_date = "From date is required";
      isValid = false;
    } else {
      updatedErrors.from_date = "";
    }

    // Validate to_date
    if (!formState.to_date) {
      updatedErrors.to_date = "To date is required";
      isValid = false;
    } else {
      updatedErrors.to_date = "";
    }

    // Validate comments
    if (!formState.comments) {
      updatedErrors.comments = "Comments are required";
      isValid = false;
    } else {
      updatedErrors.comments = "";
    }

    setErrors(updatedErrors);
    return isValid;
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
  
    // If the value contains a date in the format of date, month, and year, convert it to a different format
    // For example, if the format is "DD/MM/YYYY", convert it to "YYYY-MM-DD" before setting it in the state
    // const isDateFormat = moment(value, "DD/MM/YYYY", true).isValid();
    // const updatedValue = isDateFormat ? moment(value, "DD/MM/YYYY") : value;
    const isDateFormat = moment(value, "DD/MM/YYYY", true).isValid();
    const updatedValue = isDateFormat ? moment(value, "DD/MM/YYYY").format("DD/MM/YYYY") : value;
  
  
    setFormState((prevState) => ({
      ...prevState,
      [name]: updatedValue,
    }));
  
    // Clear error message when value is filled
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleAutocompleteChange = (event: any, newValue: string | null) => {
    setFormState((prevState) => ({
      ...prevState,
      category: newValue || "",
    }));
  };

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setFormState((prevState) => ({
      ...prevState,
      leaveType: +value,
    }));
  };

  const handleSubmit = async () => {
     
     
    try {
      setApiResponse(true);
      if (!validateFields()) {
        // Fields are not valid, stop submission
        setApiResponse(false);
        return;
      }

      const body = { ...formState, userId };
      const response = await addUserLeave(body);
      customErrorHandler(response);
      if (response?.success) {
        openSuccessNotification(response?.message);
        props?.handleclose &&  props?.handleclose();
      } else {
        customErrorHandler(response);
      }
      setApiResponse(false);
    } catch (error: any) {
      setApiResponse(false);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };
const getLeaveCount =()=>{
  if(formState.leave_type =="Sick Leave")
  {return props.leaveInfo.sick_leave_available}
  else if (formState.leave_type =="Casual Leave")
  {return props.leaveInfo.casual_leave_available} 
  else if (formState.leave_type =="Earned Leave")
  {return props.leaveInfo.earned_leave_available}
  else{
    return 0
  }
}
  return (
    <>
      <Box sx={classes.leaveDetailsWrapper}>
        <Box sx={classes.pageInfoHeader}>
          <Typography sx={classes.Heading}>New Leave Application</Typography>
          <Typography sx={classes.text}>
            Please provide the information below
          </Typography>
        </Box>

        <Box sx={classes.header} mt={5}>
          <Box>
            <Typography sx={classes.pageHeading}>Personal Details</Typography>
            <Typography sx={classes.pageText}>
              Manage your personal information to use the platform
            </Typography>
          </Box>
        </Box>

        <Grid container rowSpacing={3} columnSpacing={5}>
          <Grid item xs={12} lg={6}>
            <CustomInput
              label="Name"
              placeHolder="Full Name"
              disabled
              value={userName?.auth?.userName}
              onChange={handleInputChange}
              name="name"
            />
          </Grid>

          <Grid item xs={12} lg={6}>
            <CustomInput
              label="Leaves Remaining"
              placeHolder="04"
              disabled
              value={getLeaveCount()}
              onChange={handleInputChange}
              name="leavesRemaining"
            />
          </Grid>

          <Grid item xs={12} lg={6}>
            <Box>
              <label htmlFor="State" style={classes.label}>
                Category
              </label>
              <Autocomplete
                value={formState.leave_type}
                onChange={handleAutocompleteChange}
                inputValue={formState.leave_type}
                onInputChange={(_, newInputValue) => {
                  setFormState((prevState) => ({
                    ...prevState,
                    leave_type: newInputValue,
                  }));
                }}
                id="controllable-states-demo"
                options={options}
                sx={classes.autocomplateStyle}
                renderInput={(params) => <TextField {...params} />}
              />
              {errors.leave_type && (
                <Typography color="error">{errors.leave_type}</Typography>
              )}
            </Box>
          </Grid>

          <Grid item xs={12} lg={6}>
            <CustomInput
              label="Total Leave"
              placeHolder="Total Leave"
              disabled
              value={props.leaveInfo?.total_leave_available}
              onChange={handleInputChange}
              name="totalLeave"
            />
          </Grid>

          <Grid item xs={12} lg={6}>
            <CustomInput
              label="From Date"
              type="date"
              value={formState.from_date}
              onChange={handleInputChange}
              name="from_date"
            />
            {errors.from_date && (
              <Typography sx={classes.error}>{errors.from_date}</Typography>
            )}
          </Grid>

          <Grid item xs={12} lg={6}>
            <CustomInput
              label="To Date"
              type="date"
              value={formState.to_date}
              onChange={handleInputChange}
              name="to_date"
            />
            {errors.to_date && (
              <Typography sx={classes.error}>{errors.to_date}</Typography>
            )}
          </Grid>
          

          <Grid item xs={12} lg={6}>
            <CustomInput
              label="Reason"
              placeHolder="comments"
              value={formState.comments}
              onChange={handleInputChange}
              name="comments"
            />
            {errors.comments && (
              <Typography sx={classes.error} color="error">
                {errors.comments}
              </Typography>
            )}
          </Grid>

          <Grid item xs={12} lg={6}>
            <Typography sx={classes.leaveLabel}>Type of Leave</Typography>

            <Box sx={classes.checkBoxWarapper}>
              <CustomRadioButton
                value={1}
                disabled ={!(formState.from_date == formState.to_date)}
                checked={formState.leaveType === 1}
                onChange={handleRadioChange}
                label="Half Day"
              />

              <CustomRadioButton
                value={0}
                checked={formState.leaveType === 0}
                onChange={handleRadioChange}
                label="Full Day"
              />
            </Box>
          </Grid>

          <Grid xs={12} lg={6}>
            <Box sx={classes.buttonWraaper}>
              <CustomButton
                label="Submit"
                onClick={handleSubmit}
                buttonType="primaryBtn"
                customClasses={classes.submitStyle}
              />
            </Box>
          </Grid>
        </Grid>
        {apiResponse && <CustomLoader apiResponse={false} />}
      </Box>
    </>
  );
};

export default LeaveApplyForm;
